import cookies from 'js-cookie';
import React, { useEffect, useCallback, useContext } from 'react';
import {
    EVENT_INITIATORS,
    INTERACTION_TYPES,
} from '@zocdoc-frontend-common/utils-frontend-metrics';
import { CreateAccountNavigationContext } from 'src/Booking/components/CreateAccountContainer';
import { elementNames as createUsernameElementNames } from 'src/Booking/components/CreateUsernameForm/constants';
import { CreateUsernameFormContext } from 'src/Booking/components/CreateUsernameForm/CreateUsernameFormProvider';
import { useLoadCreateAccountView } from 'src/Booking/utils/hooks/useLoadCreateAccountView';
import { useRequirePatientInfoComplete } from 'src/Booking/utils/hooks/useRequirePatientInfoComplete';
import useWarningOnUnload from 'src/Booking/utils/hooks/useWarningOnUnload';
import CreatePasswordPageView from './CreatePasswordPageView';

const CreatePasswordPageContainer = ({
    onSignInSuccess,
    shouldShowLoginModal,
    signedIn,
    sendMetric,
    openLoginModal,
    ...viewOnlyProps
}) => {
    // Trigger the popup saying input will be lost when the user refreshes the page
    useWarningOnUnload();

    // Send back to patient info page if we don't have that data yet
    useRequirePatientInfoComplete();

    const { goBackToPreviousPage } = useContext(CreateAccountNavigationContext);

    const createUsernameFormContext = useContext(CreateUsernameFormContext);
    const skipCreateUsernameForTesting = cookies.get(
        'skipCreateUsernameForTesting'
    );

    // Send back to create username page if we don't have that data yet
    useEffect(() => {
        if (
            !createUsernameFormContext.values[
                createUsernameElementNames.email
            ] &&
            !skipCreateUsernameForTesting
        ) {
            goBackToPreviousPage();
        }
    }, [
        createUsernameFormContext.values,
        goBackToPreviousPage,
        skipCreateUsernameForTesting,
    ]);

    // Scroll to top and fire view metrics
    useLoadCreateAccountView({
        loadActionName: 'Loaded create password view',
        loadMetricName: 'booking-web-app.saw_create_password',
        sendMetric,
    });

    const onClickLoginLink = useCallback(() => {
        sendMetric({
            action: 'Click email already in use error login link',
            component: 'Email already in use error',
            element: 'Login link',
            initiator: EVENT_INITIATORS.USER,
            interactionType: INTERACTION_TYPES.CLICK,
        });
        openLoginModal();
    }, [openLoginModal, sendMetric]);

    useEffect(() => {
        if (signedIn) {
            onSignInSuccess();
        }
    }, [onSignInSuccess, signedIn]);

    const viewProps = {
        onSignInSuccess,
        shouldShowLoginModal,
        sendMetric,
        onClickLoginLink,
        ...viewOnlyProps,
    };

    return <CreatePasswordPageView {...viewProps} />;
};

export default CreatePasswordPageContainer;
